import { LoadingSpinner } from '@idexx-laboratories/spot-react';
import React from 'react';
import './Loader.scss';

interface LoaderProps {
  children?: React.ReactNode;
  loading?: boolean;
  size?: 'default' | 'small' | 'large';
}

const Loader = (props: LoaderProps): React.JSX.Element => {
  const { loading, size, children } = props;
  return (
    <div className='spot-button-loader'>
      <span className={loading ? 'hidden-content' : ''}>{children}</span>
      {loading && <LoadingSpinner size={size} />}
    </div>
  );
};

export default Loader;
